var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),_c('vue-progress-bar'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }